import React from 'react';
import { useTranslation } from 'react-i18next';
import NotificationModal from 'src/screens/shared/components/NotificationModal';

import { useBulkEnhancement } from './BulkEnhancementContext';

const BulkEnhanceConfirmModal = () => {
  const { t } = useTranslation();
  const { confirmBatch, dismissConfirmBatch, confirmBatchEnhancement, isCreatingBatch } =
    useBulkEnhancement();

  if (!confirmBatch) {
    return null;
  }

  const { mediaIds, alreadyEnhancedCount } = confirmBatch;

  return (
    <NotificationModal
      open
      title={t('vehicleScreen:bulk_enhance_confirm_title')}
      description={
        <>
          {t('vehicleScreen:bulk_enhance_confirm_description', { count: mediaIds.length })}
          {alreadyEnhancedCount > 0 ? (
            <>
              {' '}
              {t('vehicleScreen:bulk_enhance_confirm_already_enhanced', {
                count: alreadyEnhancedCount,
              })}
            </>
          ) : null}
        </>
      }
      onCancel={dismissConfirmBatch}
      mainButtonAction={() => {
        void confirmBatchEnhancement();
      }}
      mainButtonText={t('vehicleScreen:bulk_enhance_confirm_action')}
      mainButtonStyle="primary"
      secondaryButtonAction={dismissConfirmBatch}
      secondaryButtonText={t('buttons:cancel')}
      fetching={isCreatingBatch}
    />
  );
};

export default BulkEnhanceConfirmModal;
